var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingbagFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_96697_7898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49935 16.6666C7.95958 16.6666 8.33268 17.0397 8.33268 17.5C8.33268 17.9602 7.95958 18.3333 7.49935 18.3333C7.03911 18.3333 6.66602 17.9602 6.66602 17.5C6.66602 17.0397 7.03911 16.6666 7.49935 16.6666ZM13.3327 16.6666C13.7929 16.6666 14.166 17.0397 14.166 17.5C14.166 17.9602 13.7929 18.3333 13.3327 18.3333C12.8724 18.3333 12.4993 17.9602 12.4993 17.5C12.4993 17.0397 12.8724 16.6666 13.3327 16.6666ZM1.83273 2.4167C2.08763 2.07683 2.5523 1.9871 2.91188 2.1925L2.9994 2.25003L4.42252 3.31737C4.66621 3.50013 4.85376 3.74508 4.967 4.02431L5.01735 4.16665H15.722C16.6827 4.16665 17.4352 4.97358 17.3868 5.91635L17.3759 6.04004L16.995 9.08623C16.7586 10.9783 15.2707 12.4598 13.3954 12.7017L13.2066 12.7217L7.11272 13.2296L7.32899 14.1667H14.5828C15.0429 14.1667 15.4161 14.5398 15.4161 15.0001C15.4161 15.4274 15.0943 15.7796 14.6799 15.8278L14.5828 15.8334H7.32899C6.59855 15.8334 5.95909 15.3588 5.7409 14.6726L5.70501 14.5415L3.42252 4.6507L1.9994 3.58336C1.63121 3.30722 1.55659 2.78489 1.83273 2.4167Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96697_7898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingbagFill);
export default __webpack_public_path__ + "static/media/shopping bag-fill.6bb2a43bba2d8f902993ce4fe7e3f69a.svg";
export { ForwardRef as ReactComponent };